import { AppState } from "@store";
import * as React from "react";
import { connect, Dispatch } from "react-redux";
import { LoadingOverlay } from "@components";

export interface AppComponentProps {}

export interface AppComponentState {
    loginUrl: string;
}

export class AppComponent extends React.Component<AppComponentProps, AppComponentState> {
    render() {
        return <LoadingOverlay className="app-page" loading={true} />;
    }
}

export interface AppPageProps {}

export const AppPage = connect(
    (state: AppState, ownProps: AppPageProps) => ({}),
    (dispatch: Dispatch, ownProps: AppPageProps) => ({})
)(AppComponent);
